import { Dialog, DialogContent, DialogTitle } from '@material-ui/core';
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useReactToPrint } from 'react-to-print';
import { generateExcelCartilla, generatePDFCartilla } from '../../../../actions/contrataciones/contratacionesCartilla';
import { handleErrorApi } from '../../../../helpers/randoms';
import ContratacionesService from '../../../../services/ContratacionesService';
import TableGeneric from '../../../compartidos/abms/TableGeneric';
import LoadingBeforeViewData from '../../../compartidos/LoadingBeforeViewData';
import ToolbarXLSPDF from '../../../compartidos/ToolbarXLSPDF';

const CantRedes = ({ item }) => {
    const dispatch = useDispatch()
    const { centrosMedicos } = useSelector((state) => state.contratacionesCartilla);
    const { items: localidades } = useSelector(state => state.localidades)
    const { items: provincias } = useSelector(state => state.provincias)
    const { items: especialidades } = useSelector((state) => state.especialidades);

    const [open, setOpen] = React.useState(false);
    const [prestadores, setPrestadores] = React.useState(null);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const componentRef = React.useRef();

    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    });

    const getPrestadoresFormateados = () => {
        let formateados = []
        prestadores.forEach((prestador) => {
            prestador.cartillaPrestadores.forEach((cartillaPrestador) => {
                let datosDomicilio = {}
                if (cartillaPrestador.atiendeCentroPropio) {
                    const centroMedico = centrosMedicos.find(
                        (centroMedico) =>
                            centroMedico.idCentroMedico === parseInt(cartillaPrestador.idCentroMedico)
                    );

                    let localidadEncontrada = localidades.find((loc) =>
                        parseInt(loc?.id_localidad) === parseInt(centroMedico?.idLocalidad)
                    );
                    let provinciaEncontrada = provincias.find((prov) =>
                        parseInt(prov?.id_provincia) === parseInt(localidadEncontrada?.id_provincia)
                    );

                    datosDomicilio.domicilio = centroMedico?.direccion;
                    datosDomicilio.cp = centroMedico?.cp;
                    datosDomicilio.telefono = centroMedico?.telefono;
                    datosDomicilio.localidad = localidadEncontrada?.descripcion_localidad;
                    datosDomicilio.idLocalidad = localidadEncontrada.id_localidad
                    datosDomicilio.provincia = provinciaEncontrada?.descripcion_provincia;
                    datosDomicilio.idProvincia = provinciaEncontrada.id_provincia
                } else {
                    let localidadEncontrada = localidades.find((loc) =>
                        parseInt(loc?.id_localidad) === parseInt(cartillaPrestador.cartillaPrestadoresDomicilio?.idLocalidad)
                    );

                    let provinciaEncontrada = provincias.find((prov) =>
                        parseInt(prov?.id_provincia) === parseInt(localidadEncontrada?.id_provincia)
                    );


                    datosDomicilio.domicilio = cartillaPrestador.cartillaPrestadoresDomicilio?.domicilio;
                    datosDomicilio.cp = cartillaPrestador.cartillaPrestadoresDomicilio?.cp;
                    datosDomicilio.telefono = cartillaPrestador.cartillaPrestadoresDomicilio?.telefono;
                    datosDomicilio.localidad = localidadEncontrada?.descripcion_localidad;
                    datosDomicilio.provincia = provinciaEncontrada?.descripcion_provincia;
                }

                let aux = {
                    nombreApellido: prestador.nombreApellido,
                    cuit: prestador.cuit,
                    datosDomicilio,
                    centroMedico: cartillaPrestador.idCentroMedico !== null && centrosMedicos.find((e) => cartillaPrestador.idCentroMedico === e.idCentroMedico)?.descripcionCentro,
                    especialidades: cartillaPrestador.cartillaPrestadoresEspecialidades?.map((especialidad) => especialidades.find(x => x.idEspecialidades === especialidad)?.descripcionEspecialidades).join(", ")
                }

                formateados.push(aux)
            })
        })
        return formateados
    }

    const obtenerCartillaDePrestadores = async (id) => {
        try {
            const response = await ContratacionesService.traerPrestadores(id);
            const body = await response.json();
            if (response.ok) {
                setPrestadores(body)
            } else {
                throw body;
            }
        } catch (error) {
            handleErrorApi(dispatch, error, "Error al traer los prestadores de cartilla", "Ha ocurrido un error. Intente nuevamente");
        }
    }

    useEffect(() => {
        if (open) {
            obtenerCartillaDePrestadores(item.idEfectorFacturacion)
            setPrestadores(null)
        }
    }, [open])

    return (
        <>
            <div onClick={handleClickOpen} style={{ cursor: "pointer" }}>
                {item.cantRedes}
            </div>
            <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title" maxWidth="xl" fullWidth>
                <DialogTitle id="form-dialog-title">Integrantes</DialogTitle>
                <DialogContent>
                    {
                        prestadores === null
                            ?
                            <LoadingBeforeViewData />
                            :
                            <>
                                {
                                    prestadores.length > 0 &&
                                    <ToolbarXLSPDF
                                        handlePrint={handlePrint}
                                        handleExportExcel={() => dispatch(generateExcelCartilla(item.idEfectorFacturacion))}
                                        handleGeneratePdf={() => dispatch(generatePDFCartilla(item.idEfectorFacturacion))}
                                    />
                                }
                                <TableGeneric
                                    ref={componentRef}
                                    data={getPrestadoresFormateados(prestadores)}
                                    columns={[
                                        {
                                            label: "Nombre y Apellido",
                                            id: "nombreApellido",
                                            sort: true
                                        },
                                        {
                                            label: "Cuit",
                                            id: "cuit",
                                            sort: false
                                        },
                                        {
                                            label: "Domicilio",
                                            id: "datosDomicilio.domicilio",
                                            sort: false
                                        },
                                        {
                                            label: "Telefono",
                                            id: "datosDomicilio.telefono",
                                            sort: false
                                        },
                                        {
                                            label: "CP",
                                            id: "datosDomicilio.cp",
                                            sort: false
                                        },
                                        {
                                            label: "Localidad",
                                            id: "datosDomicilio.localidad",
                                            sort: true,
                                        },
                                        {
                                            label: "Provincia",
                                            id: "datosDomicilio.provincia",
                                            sort: true,
                                        },
                                        {
                                            label: "Centro Medico",
                                            id: "centroMedico",
                                            sort: true,
                                        },
                                        {
                                            label: "Especialidades",
                                            id: "especialidades",
                                            sort: false,
                                        },
                                    ]}
                                />
                            </>
                    }
                </DialogContent>
            </Dialog>
        </>
    )
}

export default CantRedes